export default __webpack_public_path__ + "static/media/support.319ccf66.png";